import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AppError } from '@app/core/errors/app-error.model';
import { FieldError } from '@app/core/errors/field-error.model';

@Component({
    selector: 'app-error-summary',
    templateUrl: './error-summary.component.html',
    styleUrls: ['./error-summary.component.scss'],
    imports: [CommonModule, TranslateModule]
})
export class ErrorSummaryComponent {
    @Input() error: AppError | string | null = null;
    @Input() fieldErrors: FieldError[] = [];

    get title(): string {
        return typeof this.error === 'object' && this.error?.title ? this.error.title : '';
    }

    get message(): string {
        if (!this.error) {
            return '';
        }

        return typeof this.error === 'string' ? this.error : this.error.message;
    }

    get errors(): FieldError[] {
        if (this.fieldErrors.length > 0) {
            return this.fieldErrors;
        }

        return typeof this.error === 'object' && this.error?.fieldErrors ? this.error.fieldErrors : [];
    }
}
